<template>
	<div class="right-con">
		<h3>{{ $t('质押借币') }}</h3>
		<div class="form-item dis-fle ali-cen">
			<el-input v-model="amount" :placeholder="$t('请输入')" @change="amountChang" size="medium" class="flex-1">
				<span slot="prefix" class="slot-prepend label txt-16">{{ $t('验资数量') }}</span>
				<span slot="suffix" class="slot-suffix value cur-poi txt-16" @click="amount = product.money">{{ $t('全部') }}</span>
			</el-input>
			<!-- <div class="rigth"></div> -->
		</div>

		<p class="tips">
			<span class="label">{{ $t('可验资金额') }}: </span>
			<span>{{ product.money || '0.00' }} {{ product.symbol || 'USDT' }}</span>
		</p>

		<div class="form-item">
			<el-input v-model="amountT" :placeholder="$t('输入存货数量后评估')" size="medium" disabled class="flex-1">
				<span slot="prefix" class="slot-prepend label txt-16">{{ $t('可借数量') }}</span>
				<span slot="suffix" class="slot-suffix suffix-img">
					<img src="@/assets/img-pc/icon6.png" />
				</span>
			</el-input>
		</div>

		<p class="tips">
			<span class="label">{{ $t('根据个人资产情况进行，同步借币额度') }}</span>
		</p>

		<div class="row-title">{{ $t('借币期限') }}</div>

		<ul class="loanterm-ul">
			<li v-for="value in dayList" :key="value" :class="{ 'active': theTermIndex == value }"
				@click="theTermIndex = value"> {{ value }}{{ $t('天') }}
			</li>
		</ul>

		<div class="data-list">
			<div class="item-">
				<span class="label">{{ $t('日币利息') }}
					<i class="el-icon-question cur-poi" @click="$refs.dialogRef.open(objData.richtext)"
						style="color: rgb(0, 240, 255); font-size: 18px;"></i></span>
				<span>{{ objData.borrow_rate || '0.00' }} %</span>
			</div>
			<div class="item-">
				<span class="label">{{ $t('总币息') }}</span>
				<span>{{ totalInterest }} USDT</span>
			</div>
			<div class="item-">
				<span class="label">{{ $t('总服务费') }}</span>
				<span>{{ objData.borrow_fee || '0.00' }} USDT</span>
			</div>
			<div class="line">
			</div>
			<div class="item-">
				<span class="label">{{ $t('预估应还') }}</span>
				<span>{{ repayment }} USDT</span>
			</div>
		</div>

		<div class="form-item">
			<el-checkbox v-model="checked">{{ $t('我已经阅读并同意') }}</el-checkbox>
			<span class="checkbox" @click="$nav.go('/pc/article?type=11')">{{ $t('借币服务协议') }}</span>
		</div>

		<div class="but cur-poi" @click="borrowSubmit">{{ $t('立即借币') }}</div>

		<dialogMode ref="dialogRef"></dialogMode>
	</div>
</template>
<script>
import { get, post } from '@/http/request'
import dialogMode from './dialog.vue'
export default {
	components: { dialogMode },
	data() {
		return {
			amount: '',
			amountT: '',
			theTermIndex: '',
			checked: false,

			objData: {},
		};
	},
	computed: {
		dayList() {
			return this.objData.day_list || []
		},
		product() {
			const da = this.objData.product
			if (Array.isArray(da)) {
				return da[0]
			} else if (da) {
				return da
			}
			return {}
		},
		totalInterest() {
			return (this.amountT * (this.theTermIndex * this.objData.borrow_rate / 100) + Number(this.objData.borrow_fee)).toFixed(2) || 0
		},
		repayment() {
			return Number(this.amountT) ? (Number(this.totalInterest) + Number(this.amountT)).toFixed(2) : 0
		},
	},
	created() {
		this.borrowGetData()
	},
	methods: {
		amountChang(value) {
			// console.log(value)
			this.amountT = Number(value) * (this.objData.borrow_limit_rate / 100) || 0
		},
		borrowGetData() {
			get(this.$apis.borrowGetData).then(res => {
				if (res.code == 1) {
					this.objData = res.data
					if (Array.isArray(this.objData.day_list) && this.objData.day_list.length > 0) {
						this.theTermIndex = this.objData.day_list[0]
					}
				}
			})
		},

		async borrowSubmit() {

			if (!this.checked) {
				this.$notify.error(this.$t('请阅读并同意借币服务协议'));
				return
			}
			const res = await post(this.$apis.borrowSubmit, {
				day: this.theTermIndex,
				product_id: this.product.id,
				amount: this.amount
			})
			if (res.code == 1) {
				this.amount = 0
				this.amountT = 0
				this.$notify.success(res.msg);  
				this.$emit('submit')
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.right-con {
	width: 516px;
	height: 651px;
	border-radius: 12px;
	border: 1px solid #2c2c3e;
	margin-left: 30px;
	background: #000;
	padding: 20px 30px;

	.but {
		width: 456px;
		height: 46px;
		line-height: 46px;
		text-align: center;
		border: 0;
		color: #000;
		font-weight: 700;
		font-size: 16px;
		border-radius: 99px;
		background: #00f0ff;
		margin-top: 20px;
	}

	.checkbox {
		color: #6592e9;
		margin-left: 5px;
		cursor: pointer;
	}

	.data-list {

		.item- {
			display: flex;
			justify-content: space-between;
			margin-bottom: 14px;
		}

		.line {
			width: 100%;
			height: 1px;
			background: #12141e;
			margin-bottom: 14px;
		}
	}

	.loanterm-ul {
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		align-items: normal;
		justify-content: space-between;

		li {
			width: 140px;
			height: 40px;
			line-height: 40px;
			border: 1px solid #84849f;
			background: #000;
			color: #fff;
			font-size: 15px;
			text-align: center;
			margin-bottom: 20px;
			border-radius: 99px;
			cursor: pointer;

			&.active {
				color: #000;
				background: #00f0ff;
				border: 1px solid #00f0ff;
			}
		}
	}

	.row-title {
		font-size: 16px;
		margin: 20px 0;
		color: #fff;
	}

	.tips {
		line-height: 12px;
		font-size: 14px;
		margin: 16px 0;
	}

	.form-item {
		.rigth {
			width: 126px;
			height: 44px;
			margin-left: 10px;
			border: 1px solid #2c2c3e;
			background: #000;
			border-radius: 6px;
			cursor: pointer;
			display: flex;
			align-items: center;
			padding: 0 20px;
		}
	}

	h3 {
		font-size: 18px;
		margin-bottom: 4px;
		font-weight: 500;
	}

	::v-deep .el-input__inner {
		text-align: right;
		height: 44px;
		line-height: 44px;
		padding-left: 130px;
		padding-right: 55px;
		font-size: 16px;
	}

	::v-deep .is-disabled {
		.el-input__inner {
			background-color: #00000000;
			border-color: #474d57;

			&::placeholder {
				color: #fff;
			}
		}
	}

	.slot-prepend,
	.slot-suffix {
		display: inline-block;
		height: 44px;
		line-height: 44px;
		padding: 0px 10px;
	}

	.suffix-img {
		display: flex;
		align-items: center;

		img {
			width: 24px;
			height: 24px;
		}
	}

	.label {
		color: #888;
	}

	.value {
		color: #fff;
	}
}
</style>